import React, { Component } from "react";
import * as Constants from "../../Constants/index"
import axios from "axios";
import swal from "sweetalert";
import LoadingButton from "../common/LoadingButton";
import SimpleReactValidator from "simple-react-validator";
// import Switch from "react-switch";
// import ReactDragListView from "react-drag-listview";

class CreateProgramMembers extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      name: this.props.resp ? this.props.resp.data.output.name : '',
      email: this.props.resp ? this.props.resp.data.output.email : '',
      mobile: this.props.resp ? this.props.resp.data.output.mobile : '',
      password: this.props.resp ? this.props.resp.data.output.password : '',
      mobileWhatsApp: this.props.resp ? this.props.resp.data.output.mobileWhatsApp : '',
      dob: this.props.resp ? this.props.resp.data.output.dob : '',
      doa: this.props.resp ? this.props.resp.data.output.doa : '',
      marital: this.props.resp ? this.props.resp.data.output.marital : '',
      sex: this.props.resp ? this.props.resp.data.output.sex : '',
      userType: 'MEMBER',
      submitting: false,


    };
  }

  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  handleNestedInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const group = target.dataset.group;

    this.setState((prevState) => ({
      ...prevState,
      [group]: {
        ...prevState[group],
        [name]: value,
      },
    }));
  };
  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount()
    );
  };


  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ submitting: true });
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);
      const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
      let compid = pathSegments[pathSegments.length - 2];
      if (this.props.resp) {
        // Get the last second segment

        try {

          axios
            .patch(
              Constants.api + "user/manage " + this.props.resp.data.output.id,
              {
                "name": this.state.name,
                "email": this.state.email,
                "mobile": this.state.mobile,
                "password": this.state.password,
                "mobileWhatsApp": this.state.mobileWhatsApp,
                "dob": this.state.dob,
                "doa": this.state.doa,
                "marital": this.state.marital,
                "sex": this.state.sex,
                "userType": "MEMBER",
                "userModelKYC": {
                  "aadharMobile": this.state.aadharMobile,
                  "aadharNumber": this.state.aadharMobile,
                  "aadharFrontUrl": this.state.aadharFrontUrl,
                  "aadharBackUrl": this.state.aadharBackUrl,
                  "aadharVerify": 0,
                  "aadharVerifiedBy": this.state.aadharVerifiedBy,
                  "aadharVerifiedOn": this.state.aadharVerifiedOn,
                  "panNumber": this.state.panNumber,
                  "panFrontUrl": this.state.panFrontUrl,
                  "panVerify": 0,
                  "panVerifiedBy": this.state.panVerifiedBy,
                  "panVerifiedOn": this.state.panVerifiedOn,
                },
                "addressWork": {
                  "address1": this.state.address1,
                  "address2": this.state.address2,
                  "address3": this.state.address3,
                  "city": this.state.city,
                  "state": this.state.state,
                  "pincode": this.state.pincode,
                  "country": this.state.country
                },
                "addressPermanent": {
                  "address1": this.state.address1,
                  "address2": this.state.address2,
                  "address3": this.state.address3,
                  "city": this.state.city,
                  "state": this.state.state,
                  "pincode": this.state.pincode,
                  "country": this.state.country
                }
              }
              ,

              {
                headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                swal("Tier Updated");
              }  else if (res.status == 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
                // this.setState({alert:res.data.msg});
                swal("Something went wrong!");
              }
            })
            .finally(() => {
              this.setState({ submitting: false });
            });
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.setState({ submitting: false });
        }
      }
      else {
        // Get the last second segment

        try {
          axios
            .post(
              Constants.api + "user/manage ",
              {
                "name": this.state.name,
                "email": this.state.email,
                "mobile": this.state.mobile,
                "password": this.state.password,
                "mobileWhatsApp": this.state.mobileWhatsApp,
                "dob": this.state.dob,
                "doa": this.state.doa,
                "marital": this.state.marital,
                "sex": this.state.sex,
                "userType": "MEMBER",
                "userModelKYC": {
                  "aadharMobile": this.state.aadharMobile,
                  "aadharNumber": this.state.aadharMobile,
                  "aadharFrontUrl": this.state.aadharFrontUrl,
                  "aadharBackUrl": this.state.aadharBackUrl,
                  "aadharVerify": 0,
                  "aadharVerifiedBy": this.state.aadharVerifiedBy,
                  "aadharVerifiedOn": this.state.aadharVerifiedOn,
                  "panNumber": this.state.panNumber,
                  "panFrontUrl": this.state.panFrontUrl,
                  "panVerify": 0,
                  "panVerifiedBy": this.state.panVerifiedBy,
                  "panVerifiedOn": this.state.panVerifiedOn,
                },
                "addressWork": {
                  "address1": this.state.address1,
                  "address2": this.state.address2,
                  "address3": this.state.address3,
                  "city": this.state.city,
                  "state": this.state.state,
                  "pincode": this.state.pincode,
                  "country": this.state.country
                },
                "addressPermanent": {
                  "address1": this.state.address1,
                  "address2": this.state.address2,
                  "address3": this.state.address3,
                  "city": this.state.city,
                  "state": this.state.state,
                  "pincode": this.state.pincode,
                  "country": this.state.country
                }
              },

              {
                headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
              }
            )
            .then((res) => {
              if (res.status === 201) {
                swal("Tier Added");
                this.setState({ create: 0 })
              }  else if (res.status == 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
                // this.setState({alert:res.data.msg});
                swal("Something went wrong!");
              }
            })
            .finally(() => {
              this.setState({ submitting: false });
            });
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.setState({ submitting: false });
        }
      }
    } else {
      this.setState({ submitting: false });
      this.validator.showMessages();
    }
    this.forceUpdate();
  };
  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  render() {

    if (this.state.create === 0) {
      window.location.reload()
    }

    return (
      <>
        <main>
          <div class="container-fluid my-3 py-3">
            <div class="row mb-5">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <form onSubmit={this.handleFormSubmit}>
                  <div class="row">
                    <div class="col-md-3 col-sm-12 col-xs-12">
                      <div class="form-group has-float-label style-two">
                        <label>Name*  </label>
                        <input class="form-control" name="name" placeholder="Enter your name" type="text" onChange={this.handleInputChange} value={this.state.name} />
                      </div>
                    </div>

                    <div class="col-md-3 col-sm-12 col-xs-12">
                      <div class="form-group has-float-label style-two">
                        <label>Mobile No.*  </label>
                        <input class="form-control" name="mobile" placeholder="Enter Mobile Number" maxLength="10" type="text" onChange={this.handleInputChange} value={this.state.mobile} />
                      </div>
                    </div>

                    <div class="col-md-3 col-sm-12 col-xs-12">
                      <div class="form-group has-float-label style-two">
                        <label>Email ID</label>
                        <input class="form-control" name="email" placeholder="Enter mail ID (Optional)" type="email" onChange={this.handleInputChange} value={this.state.email} />
                      </div>
                    </div>

                    <div class="col-md-3 col-sm-12 col-xs-12">
                      <div class="form-group has-float-label style-two">
                        <label>Password*  </label>
                        <input class="form-control" name="password" placeholder="Enter Password" type="text" onChange={this.handleInputChange} value={this.state.password} />
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <div class="form-group text-center">
                        <LoadingButton type="submit" class="btn login_btn" loading={this.state.submitting}>Submit</LoadingButton>
                        <button type="button" class="btn resetbtn" onClick={() => window.location.reload()}>Cancel</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }

}

export default CreateProgramMembers;
